import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import useTable from "@/components/useTableR";
import { Dimmer } from "@/components/spinner";
import axios from "axios";
import { Mensaje } from "@/components/mensajes2";
import moment from "moment";
import { formatMoneda } from "@/util/varios";
import Multas from "./modalMultas";
import { PrimaryButton } from "@/ui/buttons/Button";
export default function ModalGestionarMulta(props) {
  const op = require("@/modulos/datos");
  const token = localStorage.getItem("jwtToken");
  const [showModal, setShowModal] = useState(false);
  const [tipo, setTipo] = useState("comercio");
  const [selectMulta, setSelectMulta] = useState();
  const [multas, setMultas] = useState([]);
  const [deudas, setDeudas] = useState([]);
  const [historico, setHistorico] = useState([]);
  const [loading, setLoading] = useState(false);
  const [operacion, setOperacion] = useState(1);
  const [idContribuyente, setIdContribuyente] = useState("");
  const [tabActivo, setTabActivo] = useState("multas");
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [comercio, setComercio] = useState({
    codigo: "",
    rif: "",
    nombre: "",
    cedula: "",
    direccion: "",
  });
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const headCellsMultas = [
    {
      id: "1",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "ID",
      textAlign: "center",
    },
    {
      id: "2",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "FECHA",
      textAlign: "center",
    },
    {
      id: "4",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "TIPO MULTA",
      textAlign: "center",
    },
    {
      id: "5",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "CONCEPTO",
      textAlign: "center",
    },
    {
      id: "6",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "MONTO",
      textAlign: "center",
    },
    {
      id: "7",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "PAGADA",
      textAlign: "center",
    },
    {
      id: "8",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "OPCIONES",
      textAlign: "center",
    },
  ];
  const headCellsDeudas = [
    {
      id: "2",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "FECHA",
      textAlign: "center",
    },
    {
      id: "4",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "TIPO MULTA",
      textAlign: "center",
    },
    {
      id: "5",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "CONCEPTO",
      textAlign: "center",
    },
    {
      id: "6",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "MONTO",
      textAlign: "center",
    },
  ];
  const headCellsHistorico = [
    {
      id: "2",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "FECHA",
      textAlign: "center",
    },
    {
      id: "4",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "TIPO MULTA",
      textAlign: "center",
    },
    {
      id: "5",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "CONCEPTO",
      textAlign: "center",
    },
    {
      id: "6",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "MONTO",
      textAlign: "center",
    },
    {
      id: "7",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "N RECIBO",
      textAlign: "center",
    },
    {
      id: "8",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "FECHA DE PAGOS",
      textAlign: "center",
    },
  ];

  const tableMultas = useTable(multas, headCellsMultas, filterFn, true);
  const tableDeudas = useTable(deudas, headCellsDeudas, filterFn, true);
  const tableHistorico = useTable(
    historico,
    headCellsHistorico,
    filterFn,
    true,
  );
  const buscarMultas = ({ id, tipo }) => {
    setLoading(true);
    const tipoImpuesto =
      tipo === "comercio"
        ? "ACTIVIDADES ECONOMICAS"
        : tipo === "licores"
          ? "RENTAS DE LICORES"
          : "";
    const campos = `
      json_build_object(
      'multas', json_agg(json_build_object(
		'id', idmulta,
		'fecha', fechamulta, 
		'tipo', trim(m.descripcion), 
		'concepto', trim(concepto),
		'monto', monto,
    'valor', tp.valor,
		'codigoMulta', trim(codigomulta),
		'idTipoMulta', tp.idtipomulta,
		'descripcion', tp.descripcion,
		'tipoImpuesto', tp.tipoimpuesto
		))
	FILTER (WHERE fechapago IS NULL),
    'deudas', json_agg(
        json_build_object(
		'fecha', fechamulta, 
		'tipo', trim(m.descripcion), 
		'concepto', trim(concepto),
		'monto', monto,
    'valor', tp.valor
    )) FILTER (WHERE fechapago IS NULL),
     'historico', json_agg(
		json_build_object(
		'fecha', m.fechamulta,
		'tipo', trim(m.descripcion), 
		'concepto', trim(concepto),
		'monto', monto,
		'fechaPago', m.fechapago,
		'numRecibo', m.numerorecibo
	)) FILTER (WHERE fechapago IS NOT NULL)
) AS resultado
      `;
    const nomtab = ` multa m
      inner join tipomulta tp on tp.idtipomulta = m.idtipomulta
      WHERE idcontribuyente = ${id} 
  AND m.tipoimpuesto = '${tipoImpuesto}'`;
    const orden = "1=1";
    const endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.status === 200 && res.data && res.data.length > 0) {
          const { resultado } = res.data[0];
          setMultas(resultado.multas || []);
          setDeudas(resultado.deudas || []);
          setHistorico(resultado.historico || []);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto:
            error.response?.data?.message ||
            "Error al conectar con el servidor",
          icono: "error",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const acciones = (op, item) => {
    setSelectMulta(item);
    setOperacion(op);
    setShowModal(true);
  };

  const salir = () => {
    props.onHide();
  };
  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        if (props && props.contribuyente) {
          setComercio({
            codigo: props.contribuyente.idcontribuyente,
            rif: props.contribuyente.rif,
            nombre: props.contribuyente.nombre,
            cedula: props.contribuyente.cedula,
            direccion: props.contribuyente.direccion,
          });
          setTipo(props.tipo);
          setIdContribuyente(props.contribuyente.idcontribuyente);
          buscarMultas({
            id: props.contribuyente.idcontribuyente,
            tipo: props.tipo,
          });
        }
      }}
    >
      <Modal.Header className="azulGradiant px-4 py-2 text-uppercase">
        <h3 className="fs-4 fw-bold text-light m-0">Detalles de la Multa</h3>
        <button className="btn btn-sm bg-light" onClick={() => salir()}>
          <i className="fa fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex justify-content-between row col-md-12">
          <fieldset className="row border-azul rounded mx-auto col-sm-12 mb-2">
            <legend className="float-none m-0 w-auto">
              Datos del Contribuyente
            </legend>
            <div className="col-md-12 m-0 p-0 d-flex justify-content-start">
              <div className="input-group input-group-sm mb-1 px-0 col-md-12">
                <span
                  className="input-group-text border-0 bg-transparent"
                  id="inputGroup-sizing-sm"
                >
                  Código:
                </span>
                <input
                  type="text"
                  value={comercio.codigo}
                  disabled
                  className="form-control bg-transparent border-0"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                />
              </div>
            </div>
            <div className="col-md-12 m-0 p-0 d-flex justify-content-start">
              <div className="input-group input-group-sm mb-1 px-0 col-md-12">
                <span
                  className="input-group-text border-0 bg-transparent"
                  id="inputGroup-sizing-sm"
                >
                  Rif:
                </span>
                <input
                  type="text"
                  disabled
                  value={comercio.rif}
                  className="form-control bg-transparent border-0"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                />
              </div>
            </div>
            <div className="col-md-12 m-0 p-0 d-flex justify-content-start">
              <div className="input-group input-group-sm mb-1 px-0 col-md-12">
                <span
                  className="input-group-text border-0 bg-transparent"
                  id="inputGroup-sizing-sm"
                >
                  Nombre:
                </span>
                <input
                  type="text"
                  disabled
                  value={comercio.nombre}
                  className="form-control bg-transparent border-0"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                />
              </div>
            </div>
            <div className="col-md-12 m-0 p-0 d-flex justify-content-start">
              <div className="input-group input-group-sm mb-1 px-0 col-md-12">
                <span
                  className="input-group-text border-0 bg-transparent"
                  id="inputGroup-sizing-sm"
                >
                  Cédula / Rif:
                </span>
                <input
                  type="text"
                  disabled
                  value={comercio.cedula}
                  className="form-control bg-transparent border-0"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                />
              </div>
            </div>
            <div className="col-md-12 m-0 p-0 d-flex justify-content-start">
              <div className="input-group input-group-sm mb-1 px-0 col-md-12">
                <span
                  className="input-group-text border-0 bg-transparent"
                  id="inputGroup-sizing-sm"
                >
                  Dirección:
                </span>
                <input
                  type="text"
                  disabled
                  value={comercio.direccion}
                  className="form-control bg-transparent border-0"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                />
              </div>
            </div>
          </fieldset>
          <ul className="nav mb-2" id="ex-with-icons" role="tablist">
            <li className="nav-item" role="presentation">
              <a
                className={`nav-link rounded ${tabActivo === "multas" ? "text-white" : "text-dark"}`}
                style={{ backgroundColor: "#25d366" }}
                id="multas-tab"
                data-bs-toggle="tab"
                href="#multas"
                role="tab"
                aria-controls="multas"
                aria-selected="true"
                onClick={() => setTabActivo("multas")}
              >
                <i className="fas fa-money-check fa-fw me-2" />
                Multas del Agente
              </a>
            </li>
            <li className="nav-item mx-1" role="presentation">
              <a
                 className={`nav-link rounded ${tabActivo === "deudas" ? "text-white" : "text-dark"}`}
                style={{ backgroundColor: "#F93154" }}
                id="deudas-tab"
                data-bs-toggle="tab"
                href="#deudas"
                role="tab"
                aria-controls="deudas"
                aria-selected="true"
                onClick={() => setTabActivo("deudas")}
              >
                <i className="fas fa-money-check fa-fw me-2" />
                Deudas
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                 className={`nav-link rounded ${tabActivo === "historico" ? "text-white" : "text-dark"}`}
                style={{ backgroundColor: "rgb(255, 169, 0)" }}
                id="historico-tab"
                data-bs-toggle="tab"
                href="#historico"
                role="tab"
                aria-controls="historico"
                aria-selected="true"
                onClick={() => setTabActivo("historico")}
              >
                <i className="fas fa-book-open fa-fw me-2" />
                Historico
              </a>
            </li>
          </ul>
          <div className="tab-content col-12 m-0 p-0">
            <div
              className={`tab-pane fade ${tabActivo === "multas" ? "show active" : ""}`}
              id="multas"
              role="tabpanel"
              aria-labelledby="deuda-tab"
            >
              <div className="col-auto d-flex justify-content-end mb-2">
                <PrimaryButton
                  icon="fa-plus m-0"
                  onClick={() => {
                    acciones(1, "");
                  }}
                />
              </div>
              <tableMultas.TblContainer>
                <tableMultas.TblHead />
                <tbody>
                  {multas &&
                    tableMultas
                      .recordsAfterPagingAndSorting()
                      .map((item, index) => (
                        <tr
                          key={index}
                          style={{ padding: "0", fontSize: "11px" }}
                        >
                          <td
                            className="align-baseline"
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                              width: "auto",
                            }}
                          >
                            {item.id}
                          </td>
                          <td
                            className="align-baseline"
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                              width: "auto",
                            }}
                          >
                            {moment(item.fecha).format("DD/MM/YYYY")}
                          </td>
                          <td
                            className="align-baseline"
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                              width: "auto",
                            }}
                          >
                            {item.tipo}
                          </td>
                          <td
                            className="align-baseline"
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                              width: "auto",
                            }}
                          >
                            {item.concepto}
                          </td>
                          <td
                            className="align-baseline"
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                              width: "auto",
                            }}
                          >
                            {formatMoneda(
                              item.monto.toString().replace(".", ","),
                              ",",
                              ".",
                              2,
                            )}
                          </td>
                          <td
                            className="align-baseline"
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                              width: "auto",
                            }}
                          >
                            NO
                          </td>
                          <td
                            className="align-baseline"
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                              width: "auto",
                            }}
                          >
                            <button
                              className="btn btn-sm btn-info rounded-circle"
                              onClick={() => {
                                acciones(2, item);
                              }}
                            >
                              <i class="fas fa-eye"></i>
                            </button>
                            <button
                              className="btn btn-sm btn-warning rounded-circle mx-3"
                              onClick={() => {
                                acciones(3, item);
                              }}
                            >
                              <i className="fa fa-edit"></i>
                            </button>
                            <button
                              className="btn btn-sm btn-danger rounded-circle"
                              onClick={() => {
                                acciones(4, item);
                              }}
                            >
                              <i className="fa fa-trash-alt"></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                </tbody>
              </tableMultas.TblContainer>
              <tableMultas.TblPagination />
            </div>
            <div
              className={`tab-pane fade ${tabActivo === "deudas" ? "show active" : ""}`}
              id="deudas"
              role="tabpanel"
              aria-labelledby="deudas-tab"
            >
              <tableDeudas.TblContainer>
                <tableDeudas.TblHead />
                <tbody>
                  {deudas &&
                    tableDeudas
                      .recordsAfterPagingAndSorting()
                      .map((item, index) => (
                        <tr
                          key={index}
                          style={{ padding: "0", fontSize: "11px" }}
                        >
                          <td
                            className="align-baseline"
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                              width: "10px",
                            }}
                          >
                            {moment(item.fecha).format("DD/MM/YYYY")}
                          </td>
                          <td
                            className="align-baseline"
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                              width: "auto",
                            }}
                          >
                            {item.tipo}
                          </td>
                          <td
                            className="align-baseline"
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                              width: "auto",
                            }}
                          >
                            {item.concepto}
                          </td>
                          <td
                            className="align-baseline"
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                              width: "10px",
                            }}
                          >
                            {formatMoneda(
                              item.monto.toString().replace(".", ","),
                              ",",
                              ".",
                              2,
                            )}
                          </td>
                        </tr>
                      ))}
                </tbody>
              </tableDeudas.TblContainer>
              <tableDeudas.TblPagination />
            </div>
            <div
              className={`tab-pane fade ${tabActivo === "historico" ? "show active" : ""}`}
              id="historico"
              role="tabpanel"
              aria-labelledby="historico-tab"
            >
              <tableHistorico.TblContainer>
                <tableHistorico.TblHead />
                <tbody>
                  {historico &&
                    tableHistorico
                      .recordsAfterPagingAndSorting()
                      .map((item, index) => (
                        <tr
                          key={index}
                          style={{ padding: "0", fontSize: "11px" }}
                        >
                          <td
                            className="align-baseline"
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                              width: "auto",
                            }}
                          >
                            {moment(item.fecha).format("DD/MM/YYYY")}
                          </td>
                          <td
                            className="align-baseline"
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                              width: "auto",
                            }}
                          >
                            {item.tipo}
                          </td>
                          <td
                            className="align-baseline"
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                              width: "auto",
                            }}
                          >
                            {item.concepto}
                          </td>
                          <td
                            className="align-baseline"
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                              width: "auto",
                            }}
                          >
                            {formatMoneda(
                              item.monto.toString().replace(".", ","),
                              ",",
                              ".",
                              2,
                            )}
                          </td>
                          <td
                            className="align-baseline"
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                              width: "auto",
                            }}
                          >
                            {item.numRecibo}
                          </td>
                          <td
                            className="align-baseline"
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                              width: "auto",
                            }}
                          >
                            {moment(item.fechaPago).format("DD/MM/YYYY")}
                          </td>
                        </tr>
                      ))}
                </tbody>
              </tableHistorico.TblContainer>
              <tableHistorico.TblPagination />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          onClick={() => salir()}
          className="btn-sm rounded-pill btn btn-danger col-md-2"
        >
          <i className="fa fa-window-close"></i> Salir
        </button>
      </Modal.Footer>
      <Dimmer active={loading} inverted />
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <Multas
        show={showModal}
        onHide={() => setShowModal(false)}
        operacion={operacion}
        multa={selectMulta}
        tipo={tipo}
        idContribuyente={idContribuyente}
        refrescarTabla={() => buscarMultas({ id: idContribuyente, tipo: tipo })}
      />
    </Modal>
  );
}
